<script>
import axios from "axios";
import { layoutMethods } from "@/state/helpers";
import { menuItems } from "./horizontal-menu";
import { menuItemVisible, unionItems } from "@/components/management/dispatcher/access";
import { mapState } from "vuex";

/**
 * Single top bar: the menu on the left plus the header cluster (legal name, language,
 * fullscreen, user menu) that used to live in the separate dark #page-topbar.
 */
export default {
  data() {
    return {
      menuItems: menuItems,
      userEmail: "",
      languages: [
        {
          flag: require("@/assets/images/flags/russia.jpg"),
          language: "ru",
          title: "Русский",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
      ],
      current_language: "ru",
      legalNameTimer: null,
    };
  },
  created() {
    // before first render so the email is in the initial DOM
    this.userEmail = this.readUserEmail();
    this.current_language = this.$i18n.locale;
  },
  mounted() {
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i];
        break;
      }
    }
    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add("active");
        }
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active");
          var childAnchor = parent3.querySelector(".has-dropdown");
          if (childAnchor) childAnchor.classList.add("active");
        }

        const parent4 = parent3.parentElement;
        if (parent4) parent4.classList.add("active");
        const parent5 = parent4.parentElement;
        if (parent5) parent5.classList.add("active");
      }
    }

    if (this.legal_request == 0) {
      this.legalNameTimer = setTimeout(this.getLegalName, 1200);
    }
  },
  beforeDestroy() {
    if (this.legalNameTimer) {
      clearTimeout(this.legalNameTimer);
    }
  },
  computed: {
    ...mapState({
      userPermissions: state => state.authorization.userPerm,
      userRoles: state => state.authorization.userRoles,
      legal_name: state => state.legal_name.legal_name,
      legal_request: state => state.legal_name.request,
    }),
    accessItems() {
      return unionItems(this.userPermissions, this.userRoles);
    },
    currentFlagPath() {
      const current = this.languages.find(l => l.language === this.$i18n.locale);
      return current ? current.flag : "";
    },
  },
  methods: {
    ...layoutMethods,

    /**
     * Item is visible if its own perm passes or any child is visible (spec §5.2)
     */
    isVisible(item) {
      return menuItemVisible(this.accessItems, item);
    },

    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains("show")) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.add("show");
      } else if (nextEl) {
        nextEl.classList.remove("show");
      }
      return false;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    change_layout(layout) {
      return this.changeLayoutType({ layoutType: layout });
    },
    topbarLight() {
      document.body.setAttribute("data-topbar", "light");
      document.body.removeAttribute("data-layout-size", "boxed");
    },
    boxedWidth() {
      document.body.setAttribute("data-layout-size", "boxed");
      document.body.removeAttribute("data-topbar", "light");
      document.body.setAttribute("data-topbar", "dark");
    },

    // ---- header cluster (former horizontal-topbar.vue) ----

    /**
     * Mobile burger: toggles the collapsed menu.
     */
    toggleMenu() {
      const element = document.getElementById("topnav-menu-content");
      if (element) element.classList.toggle("show");
    },
    readUserEmail() {
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        return (Array.isArray(userData) && userData[0] && userData[0].email) || "";
      } catch (e) {
        return "";
      }
    },
    getLegalName() {
      axios
        .get(`/v1/users/my-legal-name`)
        .then(resp => {
          this.$store.dispatch("setLegalName", resp.data.name);
        })
        .catch(err => {
          this.$store.dispatch("addNotification", {
            text: err && err.response && err.response.data ? err.response.data.message : String(err),
            time: 6,
            color: "danger",
          });
        });
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    reloadPage() {
      window.location.reload();
    },
    setLanguage(locale) {
      const changed = this.$i18n.locale != locale;
      this.$i18n.locale = locale;
      this.current_language = locale;
      localStorage.setItem("locale", locale);
      if (changed) {
        this.reloadPage();
      }
    },
  }
};
</script>

<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 d-lg-none header-item js-menu-toggle"
          data-toggle="collapse"
          @click="toggleMenu"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>

        <router-link to="/" class="navbar-brand topnav-brand">
          <img src="@/assets/images/logo-wordmark-dark.svg" alt="copix" height="22" />
        </router-link>

        <div class="topnav-header d-flex align-items-center ml-auto">
          <span v-if="legal_name !== ''" class="topnav-legal-name d-none d-xl-inline-block text-muted mr-3">{{ legal_name }}</span>

          <b-dropdown variant="white" right toggle-class="header-item">
            <template v-slot:button-content>
              <img
                :src="currentFlagPath"
                alt="Header Language"
                height="16"
              />
            </template>
            <b-dropdown-item
              class="notify-item"
              v-for="(entry, i) in languages"
              :key="`Lang${i}`"
              :value="entry"
              @click="setLanguage(entry.language)"
              :link-class="{ active: entry.language === current_language }"
            >
              <img
                :src="`${entry.flag}`"
                alt="user-image"
                class="mr-1"
                height="12"
              />
              <span class="align-middle">{{ entry.title }}</span>
            </b-dropdown-item>
          </b-dropdown>

          <div class="dropdown d-none d-lg-inline-block ml-1">
            <button
              type="button"
              class="btn header-item noti-icon waves-effect"
              data-toggle="fullscreen"
              @click="initFullScreen"
            >
              <i class="ri-fullscreen-line"></i>
            </button>
          </div>

          <b-dropdown
            right
            variant="black"
            toggle-class="header-item"
            class="d-inline-block user-dropdown"
          >
            <template v-slot:button-content>
              <img
                class="rounded-circle header-profile-user"
                src="@/assets/images/incognito.png"
                alt="Header Avatar"
              />
              <span class="d-none d-xl-inline-block ml-1">{{ userEmail }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </template>
            <div @click="logout" class="dropdown-item text-danger js-logout" style="cursor: pointer;">
              <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
              {{ $t("navbar.dropdown.user.logout") }}
            </div>
          </b-dropdown>
        </div>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav">
            <li class="nav-item dropdown" v-for="(item, index) of menuItems" :key="index">
              <router-link
                tag="a"
                v-if="!item.subItems && isVisible(item)"
                :to="item.link"
                class="nav-link dropdown-toggle arrow-none"
              >
                <i :class="`${item.icon} mr-2`"></i>
                {{$t(item.label)}}
              </router-link>

              <a
                v-if="item.subItems && isVisible(item)"
                class="nav-link dropdown-toggle arrow-none"
                @click="onMenuClick"
                href="javascript: void(0);"
                id="topnav-components"
                role="button"
              >
                <i :class="`${item.icon} mr-2`"></i>
                {{$t(item.label)}}
                <div class="arrow-down"></div>
              </a>
              <div
                class="dropdown-menu row"
                aria-labelledby="topnav-dashboard"
                v-if="hasItems(item)"
              >
                <template v-for="(subitem) of item.subItems">
                  <router-link
                    :key="subitem.id"
                    class="col dropdown-item side-nav-link-ref"
                    v-if="!hasItems(subitem) && isVisible(subitem)"
                    :to="subitem.link"
                  >{{$t(subitem.label)}}</router-link>
                  <div class="dropdown" v-if="hasItems(subitem)" :key="subitem.id">
                    <a class="dropdown-item" href="javascript: void(0);" @click="onMenuClick">
                      {{ $t(subitem.label) }}
                      <div class="arrow-down"></div>
                    </a>
                    <div class="dropdown-menu">
                      <router-link
                        v-for="(subSubitem, index) of subitem.subItems"
                        :key="index"
                        :to="subSubitem.link"
                        class="dropdown-item side-nav-link-ref"
                      >{{ $t(subSubitem.label) }}</router-link>
                    </div>
                  </div>
                </template>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>
